import { useCallback, useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from 'packages/helpers/hotKeys';
import { useIsModalOpen } from 'packages/hooks/useIsModalOpen';

const useEditorSidebarShortcuts = ({
    setAnimationsTab,
    setDesignTab,
}: {
    setAnimationsTab?: () => void;
    setDesignTab?: () => void;
}) => {
    const isModalOpen = useIsModalOpen();

    const handleKeyDown = useCallback(
        (e: KeyboardEvent): void => {
            if (isInteractiveElement(e) || isCtrlKey(e) || isModalOpen) {
                return;
            }

            if (e.shiftKey) {
                switch (e.code) {
                    case 'KeyA': {
                        if (setAnimationsTab) {
                            setAnimationsTab();
                        }

                        break;
                    }

                    default:
                        break;
                }
            } else {
                switch (e.code) {
                    case 'KeyD': {
                        if (setDesignTab) {
                            setDesignTab();
                        }

                        break;
                    }

                    default:
                        break;
                }
            }
        },
        [setAnimationsTab, setDesignTab, isModalOpen],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
};

export default useEditorSidebarShortcuts;
